import { Outlet, Link, useLocation } from "react-router-dom";
import { Home, Car, Trophy, Map, Ticket, LogIn, LogOut, User, Menu } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";

const nav = [
  { to: "/app", icon: Home, label: "Home", end: true },
  { to: "/app/cars", icon: Car, label: "Cars" },
  { to: "/app/leaderboard", icon: Trophy, label: "Board" },
  { to: "/app/map", icon: Map, label: "Map" },
  { to: "/app/tickets", icon: Ticket, label: "Tickets" },
];

export default function AppLayout() {
  const location = useLocation();
  const { user, login, logout, hasRole } = useAuth();
  const [menu, setMenu] = useState(false);
  const isActive = (n) => (n.end ? location.pathname === n.to : location.pathname.startsWith(n.to));

  return (
    <div className="min-h-screen bg-[#0f0f11] pb-20">
      <header className="glass sticky top-0 z-40" data-testid="app-header">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center justify-between">
          <Wordmark size="text-xl" showArrow={false} />
          <div className="flex items-center gap-2">
            {user ? (
              <button onClick={() => setMenu(!menu)} className="flex items-center gap-2" data-testid="app-user-menu-btn">
                {user.picture ? <img src={user.picture} alt="" className="w-8 h-8 rounded-full border border-white/20" /> :
                  <span className="w-8 h-8 rounded-full pas-gradient grid place-items-center text-black font-bold">{user.name?.[0] || "U"}</span>}
              </button>
            ) : (
              <button onClick={login} className="pas-btn text-xs py-2 px-3" data-testid="app-login-btn"><LogIn size={14} /> Sign in</button>
            )}
          </div>
        </div>
        {menu && user && (
          <div className="max-w-2xl mx-auto px-4 pb-3 space-y-1" data-testid="app-user-menu">
            <div className="text-white font-heading text-sm px-2 py-1">{user.name}</div>
            <div className="text-[#8a8d91] text-xs px-2 pb-2">{user.roles?.join(" · ")}</div>
            <Link to="/app/register-car" onClick={() => setMenu(false)} className="block px-2 py-2 text-white/85 hover:text-[#ff7a1a] font-heading uppercase text-sm">Register a Car</Link>
            <Link to="/app/my-entries" onClick={() => setMenu(false)} className="block px-2 py-2 text-white/85 hover:text-[#ff7a1a] font-heading uppercase text-sm">My Entries</Link>
            <Link to="/app/favourites" onClick={() => setMenu(false)} className="block px-2 py-2 text-white/85 hover:text-[#ff7a1a] font-heading uppercase text-sm">Favourites</Link>
            {hasRole("judge") && <Link to="/app/judge" onClick={() => setMenu(false)} className="block px-2 py-2 text-[#b026ff] hover:text-white font-heading uppercase text-sm">Judge Scoring</Link>}
            {hasRole("admin") && <Link to="/admin" onClick={() => setMenu(false)} className="block px-2 py-2 text-[#b026ff] hover:text-white font-heading uppercase text-sm">Admin Dashboard</Link>}
            <button onClick={logout} className="w-full text-left px-2 py-2 text-white/85 hover:text-[#e8321c] font-heading uppercase text-sm flex items-center gap-2"><LogOut size={14} /> Sign out</button>
          </div>
        )}
      </header>

      <main className="max-w-2xl mx-auto px-4 py-5">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 inset-x-0 z-40 glass border-t border-white/10" data-testid="app-bottom-nav">
        <div className="max-w-2xl mx-auto grid grid-cols-5">
          {nav.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`bottomnav-${n.label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 py-3 transition-colors ${isActive(n) ? "text-[#ff7a1a]" : "text-[#8a8d91]"}`}>
              <n.icon size={20} />
              <span className="text-[10px] font-heading uppercase tracking-wide">{n.label}</span>
              {isActive(n) && <span className="absolute top-0 w-8 h-0.5 pas-gradient" />}
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
